export const useTraceId = () => {

    // Helper to generate a hex string of N bytes using native Crypto API
    const generateHex = (byteCount: number): string => {
        const bytes = new Uint8Array(byteCount);
        window.crypto.getRandomValues(bytes);
        return Array.from(bytes)
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    };

    /**
     * Generates a standard W3C 'traceparent' header.
     * Structure: version-traceId-parentId-flags
     * Example: 00-4bf92f3577b34da6a3ce929d0e0e4736-00f067aa0ba902b7-01
     */
    const generateTraceParent = (): string => {
        const version = '00';
        const traceId = generateHex(16); // 16 bytes = 32 hex chars (Global ID)
        const spanId = generateHex(8);   // 8 bytes = 16 hex chars (Span ID)
        const flags = '01';              // 01 = Recorded (Sampled)

        return `${version}-${traceId}-${spanId}-${flags}`;
    };

    /**
     * Extract the Trace ID from a raw traceparent string.
     * Useful for logging or debugging.
     */
    const extractTraceId = (header: string | null | undefined): string | null => {
        if (!header) return null;
        const parts = header.split('-');
        // Trace ID is always index 1
        return parts.length === 4 ? parts[1] : null;
    };

    return {
        generateTraceParent,
        extractTraceId
    };
};
